import React from "react";
import { Button, Icon } from "semantic-ui-react";

import { getText, stopEventPropagation } from "../../helpers";
import FilterDropdown from "../filter_dropdown/filter_dropdown";
import NewInspectionOwnerForm from "./new_inspection_owner_form";

export default function InspectionOwnerDropdown(props) {
  const {
    inspectionOwners = [],
    peopleOptions = [],
    viewOnly = false,
    onInspectionOwnersChange,
    removeInspectionOwner,
    onSaveCreateNew,
    isLoading,
  } = props;
  const options = peopleOptions.sort();
  const hasInspectionOwners = inspectionOwners.length > 0;

  return (
    <div className="inspection-owners-wrapper" onClick={stopEventPropagation}>
      <label className="inspection-owners-label">{getText("Inspection Owner")}:</label>
      <span className="inspection-owners">
        {inspectionOwners.map((inspectionOwner, index) => {
          return (
            <span className="inspection-owner" key={inspectionOwner}>
              {index > 0 && <span>, </span>}
              <span className="inspection-owner-name">{inspectionOwner}</span>
              {!viewOnly && <span className="inspection-owner-remove" onClick={(evt) => removeInspectionOwner(evt, inspectionOwner)}>&#215;</span>}
            </span>
          );
        })}
      </span>
      &nbsp;&nbsp;
      {!viewOnly && (
        <FilterDropdown
          label={hasInspectionOwners ? getText("Change Inspection Owner") : getText("Add Inspection Owner")}
          header="Assign inspection owner:"
          options={options}
          selections={inspectionOwners}
          onChange={onInspectionOwnersChange}
          searchPlaceholder="Search inspection owners"
          newPlaceholder="Enter new inspection owner"
          createForm={NewInspectionOwnerForm}
          onSaveNew={onSaveCreateNew}
          addable
          searchable
          singleSelect
          closeOnSelect
          isLoading={isLoading}
        />
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/create_inspection_link/inspection_owner_dropdown.js